export default __webpack_public_path__ + "static/media/DecorationB.63d140dc.png";